<div [ngClass]="{
  'main-container':panelWidth > marignWidth,
  'main-container-short':panelWidth <= marignWidth}">
  <div>
    <span *ngIf="panelWidth > marignWidth" class="search-span">
      <div class="search">
        <div class="input-group md-form form-sm form-2 pl-0">
          <input class="form-control my-0 py-1 amber-border" type="search" [(ngModel)]="searchText"
            (keyup.enter)="searchItem()" (change)="clearSearch()" (on)="clearSearch()"
            placeholder="{{'ph_search_picture' | translate}}" aria-label="Search">
          <div class="input-group-append" (click)="searchItem()">
            <span class="input-group-text amber lighten-3 element-over-hand search-icon-span" id="basic-text1">
              <i class="fa fa-search search-icon" aria-hidden="true"></i>
            </span>
          </div>
        </div>
      </div>
    </span>
    <span *ngIf="panelWidth > marignWidth && defaultImageType==='Multimedia'"  class="media-filter-span">
      <!-- Filter main text and button -->
      <div class="element-over-hand row media-filter-btn amber-border" (click)="showFilterDropdown()">
      <div class=column><span>{{'lbl_' + FilterMediaText | translate}}
        ({{lazyLoadingDisplayItems.length}})</span></div>
        <div class=column><span class="fa fa-angle-down"></span></div>

      <div *ngIf="isFilterDropDownOpen" class="media-filter-dropdown">
        <div *ngFor="let filter of filterTypes">
          <div *ngIf="filter.count != 0" class="element-over-hand row" (click)="filterMedia(filter.id)">
            <div class=column><img class="filter-icons"
                  src="assets/nonimage-preview/Small-Icons/small_media_type_{{filter.id}}.png"></div>
              <div class=column><span class="All-media">{{'lbl_' + filter.type | translate}} ({{filter.count}})</span></div>
            </div>
          </div>
      </div>
    </div>
    </span>

    <!-- Second Media filter -->
    <div *ngIf="panelWidth <= marignWidth && defaultImageType==='Multimedia'"> 
      <div class ="subfilter">
      <span class="media-filter-span-short">
        <!-- Filter main text and button -->
        <div class="element-over-hand row media-filter-btn-short amber-border" (click)="showFilterDropdown()">
        <div class=column><span>{{'lbl_' + FilterMediaText | translate}}
          ({{lazyLoadingDisplayItems.length}})</span></div>
          <div class=column><span class="fa fa-angle-down"></span></div>
          
        <div *ngIf="isFilterDropDownOpen" class="media-filter-dropdown-short">
          <div *ngFor="let filter of filterTypes">
            <div *ngIf="filter.count != 0" class="element-over-hand row" (click)="filterMedia(filter.id)">
              <div class=column><img class="filter-icons"
                src="assets/nonimage-preview/Small-Icons/small_media_type_{{filter.id}}.png"></div>
                <div class=column><span class="All-media">{{'lbl_' + filter.type | translate}} ({{filter.count}})</span></div>
              </div>
            </div>
        </div>
      </div>
      </span>

      </div>
    </div>

    <!-- Second search bar -->
    <div *ngIf="panelWidth <= marignWidth">
      <span class="subsearch">
        <div class="search">
          <div class="input-group md-form form-sm form-2 pl-0">
            <input class="form-control my-0 py-1 amber-border" type="search" [(ngModel)]="searchText"
              (keyup.enter)="searchItem()" (change)="clearSearch()" (on)="clearSearch()"
              placeholder="{{'ph_search_place' | translate}}" aria-label="Search">
            <div class="input-group-append" (click)="searchItem()">
              <span class="input-group-text amber lighten-3 element-over-hand search-icon-span" id="basic-text1">
                <i class="fa fa-search search-icon" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </div>
      </span>
    </div>

    <!-- Media filter -->
    <div *ngIf="lazyLoadingDisplayItems.length > 0"
      [ngClass]="{'image-list':panelWidth > marignWidth,'image-list-short':panelWidth <= marignWidth}">
      <div *ngFor="let item of lazyLoadingDisplayItems; let i = index"
        [ngClass]="{'single-card':panelWidth > marignWidth,'single-card-short':panelWidth <= marignWidth}">
        <div [id]=i
          [ngClass]="{'default-image' : item.id == defaultItemIds[0] && isDefaultItemSelected && !isDefaultItemDeselected,'image-container':panelWidth > marignWidth,'image-container-short':panelWidth <= marignWidth}">
          <img class="btn-card element-over-hand" (click)="showDropDown(item.id)"
            src="assets/multimedia-module/edit.png">
          <img
            *ngIf="!isFullScreenPopUp && isItemSelected && selectedItemId == item.id &&  item.id != defaultItemIds[0]"
            class="btn-card" src="assets/multimedia-module/selected.png">
          <div *ngIf="item.mediaUrl">
            <img class="image" loading="lazy"
              [src]="item.mediaType === 1 ? [item.mediaUrl] + timeTag : 'assets/nonimage-preview/Large-Icons/media_type_[item.mediaType].png'"
              [ngClass]="{'focus-image': !isFullScreenPopUp && isItemSelected && selectedItemId == item.id && item.id != defaultItemIds[0]}"
              (click)="selectImage(item)" (error)='onItemError(item, $event)'>
          </div>      
          <div *ngIf="!item.mediaUrl">
            <img class="image non_image" loading="lazy"
             src="assets/place/{{defaultImageType}}_default.png"
            [ngClass]="{'focus-image': isItemSelected && selectedItemId == item.id && item.id != defaultItemIds[0]}"
            (click)="selectImage(item)" (error)='onItemError(item, $event)'>
          </div>

          <img class="corner-sign"
            *ngIf="!isFullScreenPopUp && item.id == defaultItemIds[0] && isDefaultItemSelected  && !isDefaultItemDeselected"
            src="assets/multimedia-module/corner-sign.png">
          <div>
            <div *ngIf="isDropDownOpen && selectedDropDownId == item.id" class="content-box">
              <div class="element-over-hand"><span class="fa fa-edit"></span><span class="list-edit"
                  (click)="editSelectedItem(item)">{{"lbl_edit" | translate}}</span></div>
              <div class="element-over-hand"><span class="fa fa-trash-o"></span><span class="list-delete"
                  (click)="openConsent(item)">{{"lbl_delete" | translate}}</span></div>
            </div>
          </div>
          <div *ngIf="item.caption !== '' " class="title-container title-text">{{item.caption}}</div>
          <!-- <div *ngIf="item.caption === '' " class="edit-title-container title-text" (click)="ShowNotImplemented()">{{"lbl_enter_title" | translate}}</div> -->
        </div>
      </div>
    </div>


    <div *ngIf="lazyLoadingDisplayItems.length <= 0" class="image-list">
    </div>
  </div>